module.exports = __webpack_public_path__ + "static/media/Formato_Actualizar_documentos_imbera.7a903e24.xlsx";